export default __webpack_public_path__ + "static/media/Subjugator Staff.b22aff2b.jpg";